import React, { Component } from 'react';
import { Navigate, Outlet } from 'react-router-dom'
import { connect } from 'react-redux';
import withRouter from './WithRouter';


// const ProtectedRoute = () => {
// console.log('this.props---------------------------------');
// console.log(this.props);
//   let auth = {'token':true}
// return (
//     auth.token ? <Outlet/> : <Navigate to='/login'/>
//   )
// }

class ProtectedRoute extends Component {
    constructor() {
        super();
        this.state = {
            isAuthenticated: false,
            errors: {}
        }
    }

    componentDidUpdate(prevProps) {
        console.log('login.props', this.props);
        if(prevProps.auth.isAuthenticated !== this.props.auth.isAuthenticated) {
            this.setState({isAuthenticated: this.props.auth.isAuthenticated});

            // this.props.history.push('/')
            // if(this.props.auth.isAuthenticated === true) {
            // console.log('componentDidUpdate this.props.auth.isAuthenticated', this.props.auth.isAuthenticated);
                // this.props.navigate('/')
            // }
        }
        if(prevProps.errors !== this.props.errors) {
            this.setState({
                errors:  this.props.errors
            });
        }
    }
    render() {
        const {errors} = this.state;
        let auth = this.props.auth.isAuthenticated;
    
        return(
            <div>
                {auth ? <Outlet/> : <Navigate to='/login'/>}
            </div>
        )
    }    
}




const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.errors
})

export default connect(mapStateToProps)(withRouter(ProtectedRoute))